import Grid from '@mui/material/Grid'
import { useCallback, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import PageContainer from '../components/layout/PageContainer'
import { authRequest } from '../util/api/auth-api'
import useUser from '../util/auth/useUser'
import handleError from '../util/handleError'
import checkToken from '../util/auth/checkToken'

const AutoLogin = () => {
  const [, setUser] = useUser()

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const handlePopulateUser = useCallback(async () => {
    try {
      await checkToken()

      const { user } = await authRequest.user.account.get({ token: '' })

      setUser(user)

      const cb = searchParams.get('cb')

      if (cb) {
        navigate(cb)
      } else {
        navigate('/')
      }
    } catch (err) {
      handleError(err)
    }
  }, [setUser, searchParams, navigate])

  useEffect(() => {
    const timeout = setTimeout(() => {
      handlePopulateUser()
    }, 10)

    return () => clearTimeout(timeout)
  }, [handlePopulateUser])

  return (
    <PageContainer>
      <Grid container alignItems="center">
        <Grid item>Logging in...</Grid>
      </Grid>
    </PageContainer>
  )
}

export default AutoLogin
